module.exports = __webpack_public_path__ + "media/images/brand/favicon-02-ea16ce9518b39f7fb6e25910f6b48e6f.png";